import React from 'react';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { switchRole } from '../redux/user/actions';

const SwitchBackToSuperAdmin = () => {
  const language = useSelector((state) => state?.auth?.language);
  const isLoggedIn = useSelector((state) => state?.auth?.login);
  const isSwitched = useSelector((state) => state?.user?.isSwitched);
  const currentRole = useSelector((state) => {
    const userRole = state?.auth?.user?.role;
    const meUserRole = state?.auth?.me?.user?.roles?.[0];
    const meRootRole = state?.auth?.me?.roles?.[0];
    return userRole || meUserRole || meRootRole;
  });
  const location = useLocation();
  const dispatch = useDispatch();

  const hideSwitchBackToSuperadmin = location.pathname.includes('administrative_billing_details_submitted');
  const canShowSwitchBack = isLoggedIn && currentRole === 'merchant' && isSwitched === true && !hideSwitchBackToSuperadmin;

  if (!canShowSwitchBack) return null;

  const handleSwitchBackToAdmin = () => {
    dispatch(switchRole({ switch_back: true }));
  };
  return (
    <Button type="default" style={{ width: '100%' }} onClick={handleSwitchBackToAdmin}>
      {language?.content?.SWITCH_BACK_TO_SUPERADMIN || 'Switch back to Superadmin'}
    </Button>
  );
};

export default SwitchBackToSuperAdmin;
